import { useToast } from '@chakra-ui/react'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useSwitchChain } from 'wagmi'
import { NetworkDto } from '../types/coreApi-types'

interface NetworkStatusIndicatorProps {
  currentChainId?: number
  expectedNetwork: NetworkDto | null
  expectedChainId?: number
  className?: string
}

const NetworkStatusIndicator: React.FC<NetworkStatusIndicatorProps> = ({
  currentChainId,
  expectedNetwork,
  expectedChainId,
  className = '',
}) => {
  const toast = useToast()
  const { switchChainAsync, isPending: isSwitching } = useSwitchChain()

  const isCorrectNetwork = currentChainId === expectedChainId
  const isWalletConnected = !!currentChainId

  if (!expectedNetwork || !expectedChainId) {
    return null
  }

  if (!isWalletConnected) {
    return (
      <div
        className={`flex items-center gap-3 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg ${className}`}
      >
        <div className="text-yellow-600 dark:text-yellow-400">
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </div>
        <div>
          <p className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
            Wallet not connected
          </p>
          <p className="text-xs text-yellow-700 dark:text-yellow-300">
            Please connect your wallet to continue
          </p>
        </div>
      </div>
    )
  }

  if (isCorrectNetwork) {
    return null
    // return (
    //   <div
    //     className={`flex items-center gap-3 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg ${className}`}
    //   >
    //     <div className="text-green-600 dark:text-green-400">
    //       <FontAwesomeIcon icon={faCheckCircle} />
    //     </div>
    //     <div>
    //       <p className="text-sm font-medium text-green-800 dark:text-green-200">
    //         Connected to {expectedNetwork.name}
    //       </p>
    //       <p className="text-xs text-green-700 dark:text-green-300">
    //         You're on the correct network
    //       </p>
    //     </div>
    //   </div>
    // )
  }

  const handleSwitchNetwork = async () => {
    try {
      await switchChainAsync({ chainId: expectedChainId })
      toast({
        title: 'Network switched successfully',
        description: `Switched to ${expectedNetwork.name}`,
        status: 'success',
        duration: 3000,
      })
    } catch (error: any) {
      toast({
        title: 'Failed to switch network',
        description:
          error.message || 'Please switch network manually in your wallet',
        status: 'error',
        duration: 5000,
      })
    }
  }

  return (
    <div
      className={`flex items-center justify-between p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg ${className}`}
    >
      <div className="flex items-center gap-3">
        <div className="text-red-600 dark:text-red-400">
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </div>
        <div>
          <p className="text-sm font-medium text-red-800 dark:text-red-200">
            Wrong network detected
          </p>
          <p className="text-xs text-red-700 dark:text-red-300">
            Please switch to {expectedNetwork.name} to continue
          </p>
        </div>
      </div>
      <button
        onClick={handleSwitchNetwork}
        disabled={isSwitching}
        className="px-3 py-1.5 text-xs font-medium text-red-700 dark:text-red-200 bg-red-100 dark:bg-red-800/30 hover:bg-red-200 dark:hover:bg-red-800/50 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSwitching ? 'Switching...' : `Switch to ${expectedNetwork.name}`}
      </button>
    </div>
  )
}

export default NetworkStatusIndicator
